import { Skeleton } from "@/app/components/shadcn/skeleton";

const PopularSearchesSkeleton = () => {
  return (
    <div className="space-y-1">
      <Skeleton className="h-4 w-32 mb-2" />
      <div className="flex items-center flex-wrap gap-1.5 sm:gap-2">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton 
            key={i} 
            className="h-7 sm:h-8 w-16 sm:w-20 rounded-md" 
          />
        ))}
      </div>
    </div>
  );
};

export default PopularSearchesSkeleton;